'use strict';
var utils = require('./analytics-utils');
var events = require('../../../../../../app_bata_sfra/cartridge/client/default/js/analytics/analytics-events');

/**
 * @description variationClick listener
 * @param response {Object} an object that contains the fullproduct as an attribute (response.product)
 */
$('body').on('product:afterAttributeSelect', function(e, response) {
    var variationType = 'unknown'; // Default value
    var variationElement;

    if (response.container && Array.isArray(response.container.prevObject) && response.container.prevObject.length > 0 && response.container.prevObject[0]) {
        variationElement = response.container.prevObject[0].className || '';

        if (variationElement.includes('size')) {
            variationType = 'size';
        } else if (variationElement.includes('color')) {
            variationType = 'color';
        }
    }

    utils.variationClickHelper(response.data.product, variationType);
});

/**
 * @description addToCart listener
 * @param data {Object} a data object containing:
 *             -productID: the id of the product added to the cart with pageType,
 *             -tryOnDesktopClick: true if the user clicked on the tryon button on Desktop,
 *             -tryOnMobileRedirect: true if the user used the tryon funcionality and got redirected back on Mobile
 */
$('body').on('analytics:addToCart', function(e, data) {
    var $product,
        analyticsTileSelector = '.analytics-ProductList .analytics-product.' + data.productID,
        tile = $(analyticsTileSelector),
        //IN-AR TRY ON
        arTryonInfo = {};

    //tryOnDesktopClick and tryOnMobileRedirect are not null only if the tryon logic is active
    if (data.tryOnDesktopClick && data.tryOnDesktopClick !== null && data.tryOnMobileRedirect && data.tryOnMobileRedirect !== null) {
        arTryonInfo.tryOnDesktopClick = data.tryOnDesktopClick;
        arTryonInfo.tryOnMobileRedirect = data.tryOnMobileRedirect;
    } else {
        arTryonInfo = null;
    }
    //the tile will be > 0 only if the event is originated outside the PDP
    if (tile.length > 0) {
        $product = tile;
    } else {
        $product = $('.analytics-productPDP');
    }

    if (data.pageType === 'cart') {
        analyticsTileSelector = '.analytics-cart > .analytics-product.' + data.productID;
        tile = $(analyticsTileSelector);
        $product = tile;
    }

    utils.addToCartHelper($product, arTryonInfo);
});

/**
 * @description removeFromCart listener
 * @param pid {String} the id of the product added to the cart
 * @param pageType {String} the page type where the action is committed
 */
$('body').on('analytics:removeFromCart', function(e, data) {
    var $product;
    //the cart tiles must be the at first child level of analytics-cart
    var analyticsTileSelector = '.analytics-cart > .analytics-product.' + data.productID;
    var tile = $(analyticsTileSelector);

    $product = tile;
    utils.removeFromCartHelper($product, data.pageType, data.singleItem);
});

$('body').on('analytics:selectExpressCheckout', function (e, data) {
    utils.selectExpressCheckout(data);
});

$('body').on('analytics:expressCheckout', function (e, order) {
    utils.expressCheckout(order);
});

/**
 * @description removeFromCartBySystem listener
 */
$('body').on('analytics:removeFromCartBySystem', function() {
    utils.removeFromCartByUnavailabilityModal();
});

/**
 * @description addToWishlist listener
 * @param pid {String} the id of the product added
 */
$('body').on('analytics:addToWishlist', function(e, pid) {
    var $analyticsProduct;
    if (utils.getPageType() === "product") {
        // PDP
        $analyticsProduct = $('.analytics-productPDP');
    } else {
        $analyticsProduct = $('.analytics-product.' + pid);
    }
    utils.addToWishlistHelper(pid, $analyticsProduct);
});

/**
 * @description removeFromWishlist listener
 * @param pid {String} the id of the product removed
 */
$('body').on('analytics:removeFromWishlist', function(e, pid) {
    var $analyticsProduct;
    if (utils.getPageType() === "product") {
        $analyticsProduct = $('.analytics-productPDP');
    } else {
        $analyticsProduct = $('.analytics-product.' + pid);
    }
    utils.removeFromWishlistHelper(pid, $analyticsProduct);
});

/**
 * @description launch the checkout update data and impressions
 */
$('body').on('analytics:checkoutUpdateState', function() {
    utils.checkoutUpdate();
});

/**
 * @description collect the new product impressions
 */
$('body').on('analytics:productsLoaded', function() {

    //get the number of the products already registered, then collect the new products and launch the impression
    var numberProductAlreadyDisplayed = window.bata_com_ns.analytics.productsDisplayed || 0;
    var products = utils.getProductsData(numberProductAlreadyDisplayed);
    var ga4Products = utils.ga4GetProducts(products);
    events.ga4ViewItemList(window.bata_com_ns.analytics.currency, ga4Products);
    events.trackProductImpression(window.bata_com_ns.analytics.currency, products);
});

/**
 * @description collect the new search suggestion products
 */
$('body').on('analytics:searchProductLoaded', function(e, searchTerm) {
    let searchData = {
        resultsNumber: $('.js-analytics-searchProduct [id^="product-"]').length || 0,
        searchMethod: "autosuggested",
        searchTerm: searchTerm
    };

    if (searchData.resultsNumber > 0) {
        var products = utils.getProductsDataSearch(0);
        var ga4Products = utils.ga4GetProducts(products);

        events.ga4SuccessfulSearch(searchData);
        events.ga4ViewItemList(window.bata_com_ns.analytics.currency, ga4Products);
        events.trackProductImpression(window.bata_com_ns.analytics.currency, products);
    } else {
        events.ga4UnsuccessfulSearch(searchData);
    }
});

$('body').on('analytics:nextImagePDP', function() {
    const $activeItem = $('.slick-slide.slick-current.slick-active .js-analytics-nextImagePDP-active');

    if (!$activeItem.length) {
        return;
    }

    const imageData = {
        itemId: $activeItem.data('product-id'),
        colorVariant: $activeItem.data('color-variant'),
    };

    events.ga4ViewNextImagePDP(imageData);

});

/**
 * @description standard search
 */
$('body').on('analytics:searchProduct', function(e, searchTerm) {
    if (searchTerm && searchTerm.length) {
        var searchData = {
            searchTerm: searchTerm,
            searchType: "standard"
        };
        events.ga4SearchProduct(searchData);
    }
});

/**
 * @description user clicked on an product image on the product description page
 */
$(document).on('click', '.cc-pdp-carousel-item[data-target="#pdpImgModal"]', function() {
    events.ga4OpenPdpImage();
});

/**
 * @description It is triggered when a user clicks the "X" button on the search bar, which is
 * used to clear the text entered by the user.
 */
$(document).on('click', '.js-resetSearch.cc-search__reset', function() {
    events.ga4ClearSearch();
    return true;
});

/**
 * @description register the product click (PLP. CART, CAROUSELS ETC.)
 */
$(document).on('click', 'a.js-analytics-productClick', function(e) {
    e.preventDefault();

    let $product = $(this);
    let url = $product.attr('href'),
        productId = $product.data('analytics-product-id'),
        $analyticsProduct;
    if ($product.hasClass("js-analytics-suggestionProduct")) {
        // Product suggestion on product search
        $analyticsProduct = $('.analytics-product-search.' + productId);
    } else {
        $analyticsProduct = $('.analytics-product.' + productId);
    }

    if ($product.closest('.cc-menu__productsSection').length > 0) {
        $analyticsProduct.data('listId', 'menu - trending');
    }

    let products = utils.productClickHelper($analyticsProduct),
        analyticsInfo = window.bata_com_ns.analytics;

    // save GA4 item list id
    try {
        let listId = utils.ga4GetProductItemListId(products && products.length && products[0]);
        window.sessionStorage.setItem("analyticsListId", listId);
    } catch (error) {
        // session storage not supported
    }

    // Trigger the productClick event - GA3
    events.productClick(analyticsInfo.currency, analyticsInfo.pageType, products);
    // Trigger the selectItem event - GA4
    let ga4Products = utils.ga4GetProducts(products);
    events.ga4SelectItem(window.bata_com_ns.analytics.currency, ga4Products);

    window.location.href = url;
});

/**
 * @description register the PDP product size click
 */
$(document).on('click', 'li.js-analytics-selectSizePDP', function() {
    const $product = $(this);
    const productId = $product.data('pid'),
        selectedSize = $product.data('display-value');

    if (productId && selectedSize) {
        events.ga4SelectSize(productId, selectedSize);
    }
});

/**
 * @description register the PDP product color click
 */
$(document).on('click', '.js-analytics-selectColorPDPImage', function() {
    const $product = $(this).closest('button.js-colorAttribute');
    const productId = $product.data('pid'),
        selectedColor = $product.data('value');

    if (productId && selectedColor) {
        events.ga4SelectColor(productId, selectedColor);
    }
});

/**
 * @description user clicked on a size guide link on a PDP page
 */
$(document).on('click', '#size-guide-asset', function() {
    events.ga4SelectSizeGuide();
    return true;
});

/**
 * @description user clicked on a wishlist link in the account menu
 */
$(document).on('click', '.menu-container a[href*="wishlist"]', function() {
    events.ga4SelectWishlist();
    return true;
});

/**
 * @description user clicked on a wishlist link in the header
 */
$(document).on('click', '.wishlistLink', function() {
    events.ga4SelectWishlist();
    return true;
});

/**
 * @description user clicked on a search bar in the header
 */
$(document).on('click', '.js-headerSearchButton', function () {
    events.ga4StartSearch();
});

/**
 * @description register the click on a suggested product
 */
$(document).on('click', '.js-analytics-suggestionProduct', function() {
    events.trackGAEvent('Ecommerce', 'Suggestion Click', $(this).attr('href'));
});

/**
 * @description register the display of the cookiesbar
 */
$('body').on('analytics:showCookieBar', function() {
    events.trackGAEvent('cookie bar', 'shown', '-', 0, true);
});

/**
 * @description register the closing of cookiesbar
 */
$('.js-cookies-bar-close').on('click', function() {
    events.trackGAEvent('cookie bar', 'accepted', '-', 0, true);
});

/**
 * @description register the click on a promotional banner
 */
$(document).on('click', 'a.js-analytics-banner, a.js-analytics-banner-button', function(e) {
    e.preventDefault();
    var analyticsPromotionsData = [];
    var $banner = $(this);
    var url = $banner.attr('href');

    if ($banner.data("analytics-title") && $banner.data("analytics-title") !== "" && $banner.data("analytics-title") !== "No title") {
        analyticsPromotionsData.push({
            'id': $banner.data("analytics-title"),
            'name': $banner.data("analytics-title")
        });
        events.ga4SelectContent({
            contentId: $banner.data("analytics-title"),
            contentType: 'banner',
            contentName: $banner.data("analytics-title")
        });
        events.ga4SelectPromotion({
            promotionId: $banner.data("analytics-title"),
            promotionName: $banner.data("analytics-title")
        });
        events.PageDesignerPromoClick(analyticsPromotionsData);
    }

    window.location.href = url;
});

$(document).on('click', '.js-analytics-selectContentBrand .cc-component-textbox-cta', function(e) {
    const brandElement = $(this).closest('.js-analytics-selectContentBrand');
    const heroBannerElement = $(this).closest('.js-analytics-herobanner');

    if (!brandElement.length || !heroBannerElement.length) {
        return;
    }

    const contentType = brandElement.attr('data-analytics-select-content-brand');
    const contentName = heroBannerElement.attr('data-analytics-select-content-name');
    const contentId = heroBannerElement.attr('data-analytics-select-content-id');

    if (!contentType || !contentName || !contentId) {
        return;
    }

    const selectContentData = {
        contentId: contentId,
        contentType: `${contentType} - banner content`,
        contentName: contentName
    };

    events.ga4BrandSelectContent(selectContentData);
});

/**
 * @description the user select a product sorting rule
 * @param sorting {Int} the sort id selected
 */
$('body').on('analytics:updateProductSorting', function(e, data) {
    events.ga4ClickFilter("Radio", "Sort by", data.sorting);
    events.trackGAEvent(window.bata_com_ns.analytics.pageType, 'sorting', data.sorting);
});

/**
 * @description register the refinement clicks (not the price one)
 */
$('.container').on('click', '.js-analytics-refinement', function(e) {
    e.preventDefault();
    var $refinement = $(this);
    events.ga4ClickFilter("Checkbox", $refinement.data('refinement-id'), $refinement.data('refinement-value'));
    events.trackGAEvent(window.bata_com_ns.analytics.pageType, 'filter - ' + $refinement.data('refinement-id'), $refinement.data('refinement-value'));
});

/**
 * @description register the category clicks
 */
$('.container').on('click', '.js-categoryItem', function(e) {
    e.preventDefault();
    var $refinement = $(this);
    events.ga4ClickFilter("Category selection", $refinement.data('category-id'), $refinement.data('category-title'));
    events.trackGAEvent(window.bata_com_ns.analytics.pageType, 'filter - ' + $refinement.data('category-id'), $refinement.data('category-title'));
});

/**
 * @description register the "proceed to checkout" button click from cart page
 */
$('#cart-page-checkout-btn').on('click', function(e) {
    e.preventDefault();
    utils.checkouStepHelper(1, 'cart', true);
});

/**
 * @description register the "proceed to checkout" button click from the minicart
 */
$('body').on('analytics:cartSubmit', function() {
    utils.checkouStepHelper(1, 'minicart', true);
});

/**
 * @description register the checkout step
 * @param step {Int} the step number
 * @param option {Object} various information, step based
 */
$('body').on('analytics:checkoutStep', function(e, data) {
    //step 3 and 4 replace the products's informations displayed, so we need to extract them directly from the order object
    if (data.order) {
        const checkbox = $('.adyen-checkout__checkbox__input[name="storeDetails"]');
        if (checkbox.length) {
            data.order.paymentMethodSaved = checkbox.prop('checked');
        } else {
            data.order.paymentMethodSaved = false;
        }
        utils.updateCheckoutData(data.step, data.option, data.order);
    } else {
        utils.checkouStepHelper(data.step, data.option);
    }
});

/**
 * @description register the second checkout step
 */
$('body').on('analytics:loginStep', function (e, data) {
    var options = $('#checkout-main').attr('data-customer-type') === 'registered' ? 'Logged In' : 'Guest';
    utils.checkouStepHelper(data.step, options, false);
});

/**
 * @description a new user has registered from the registration form
 * @param customerId {String} the ID of the customer registered
 */
$('body').on('analytics:registration', function(e, data) {
    events.ga4SignUp({
        method: 'email',
        customerCrmId: data.customerCrmId,
        signupType: data.signupType || 'standard'
    });
    events.registration(data.customerId, data.email, data.phone);
});

/**
 * @description new registration submit in checkout with lightregistration
 */
$('body').on('analytics:registrationCheckout', function() {
    events.ga4SignUpCheckout({
        signupType: 'checkout'
    });
});

/**
 * @description a user has logged in
 * @param customerCrmId {String} the CRM ID of the logged in customer
 */
$('body').on('analytics:login', function(e, data) {
    events.ga4Login({
        method: data.method || 'email',
        customerCrmId: data.customerCrmId,
        loginType: data.loginType || (data.isLoginCheckout ? 'checkout' : 'standard')
    });
    events.login(data.customerCrmId, data.email);
});

/**
 * @description socialShareClick event on PDP
 */
$('a.js-analytics-socialIcon').on('click', function() {
    var $social = $(this);

    var socialName = $social.data('share'),
        productId = $social.closest('ul.social-icons').data('analytics-pid'),
        elementId = $social.data('id'),
        elementText = $social.attr('title'),
        linkUrl = $social.attr('href'),
        linkDomain = linkUrl ? new URL(linkUrl).hostname : null,
        type =  $social.data('content-type');

    var contentType = 'product detail page';
    events.ga4Share({
        method: socialName,
        contentType: contentType,
        itemId: productId,
        elementId: elementId,
        elementText: elementText,
        linkUrl: linkUrl,
        linkDomain: linkDomain,
        content_type: linkDomain,
        type: type
    });
    events.trackGAEvent(contentType, 'social media sharing - ' + socialName, productId);
});

/**
 * @description storeAvailibility event on PDP
 */
$('body').on('analytics:storeAvailibility', function() {
    events.trackGAEvent('storeAvailibility', 'click', $('button#findInStoreButton').data('pid'));
});

/**
 * @description Handles click on the first level category and tracks the event
 */
$('.cc-menu__level__link.cc-menu__firstLevel__link').on('click', function() {
    var $category = $(this).closest('.cc-menu__level__link.cc-menu__firstLevel__link');
    var categoryName = $category.attr('aria-label') || $category.text().trim();
    events.ga4ClickMenuNav(1, categoryName);
});

/**
 * @description Handles click on the second level category of menu
 */
$('.cc-menu__secondLevel__link-wrapper .cc-menu__level__link.cc-menu__secondLevel__link').on('click', function() {
    var $category = $(this);
    var categoryName = $category.attr('aria-label') || $category.text().trim();
    var parentCatName = $(this).closest('.cc-menu__level.cc-menu__secondLevel').siblings('.cc-menu__level__link.cc-menu__firstLevel__link').attr('aria-label');
    events.ga4ClickMenuNav(2, parentCatName + " - " + categoryName);
    events.trackGAEvent('dropdown', parentCatName, categoryName);
});

/**
 * @description Handles click on the second level content links of menu
 */
$('.cc-menu__secondLevel__content-link__item a').on('click', function() {
    var $link = $(this);
    var categoryName = $link.text().trim();
    events.ga4ClickMenuNav(2, categoryName);
});

/**
 * @description Handles click on the third level category of menu
 */
$('.cc-menu__level__link.cc-menu__thirdLevel__link').on('click', function() {
    var $category = $(this);
    var thirdCatName = $category.attr('aria-label') || $category.text().trim();
    var secondCatName = $category.closest('.cc-menu__thirdLevel').prev('.cc-menu__secondLevel__link-wrapper').find('.cc-menu__secondLevel__link').attr('aria-label') || $category.closest('.cc-menu__thirdLevel').prev('.cc-menu__secondLevel__link-wrapper').find('.cc-menu__secondLevel__title').text().trim();
    var firstCatName = $category.closest('.cc-menu__secondLevel').siblings('.cc-menu__level__link.cc-menu__firstLevel__link').attr('aria-label') || $category.closest('.cc-menu__secondLevel').siblings('.cc-menu__level__link.cc-menu__firstLevel__link').find('.cc-menu__firstLevel__title').text().trim();
    var parentCatName = firstCatName + ' - ' + secondCatName;
    events.ga4ClickMenuNav(3, parentCatName + " - " + thirdCatName);
    events.trackGAEvent('dropdown', parentCatName, thirdCatName);
});

/**
 * @description Handles click on the highlights section buttons of third level menu
 */
$('.cc-menu__HighlightsSection__cta').on('click', function() {
    var $button = $(this);
    var buttonText = $button.text().trim();
    var secondCatName = $button.closest('.cc-menu__HighlightsSection').prev('.cc-menu__secondLevelColumn').find('.cc-menu__secondLevel__link').attr('aria-label') || $button.closest('.cc-menu__HighlightsSection').prev('.cc-menu__secondLevelColumn').find('.cc-menu__secondLevel__title').text().trim();
    var firstCatName = $button.closest('.cc-menu__secondLevel').siblings('.cc-menu__level__link.cc-menu__firstLevel__link').attr('aria-label') || $button.closest('.cc-menu__secondLevel').siblings('.cc-menu__level__link.cc-menu__firstLevel__link').find('.cc-menu__firstLevel__title').text().trim();
    var parentCatName = firstCatName + ' - ' + secondCatName;
    events.ga4ClickMenuNav(3, parentCatName + " - " + buttonText);
    events.trackGAEvent('highlight section', parentCatName, buttonText);
});

/**
 * @description Handles click on the multiple block section links
 */
$('.cc-menu__blockForMultipleBlocksSection__link').on('click', function() {
    var $link = $(this);
    var blockTitle = $link.find('.cc-menu__blockForMultipleBlocksSection__text').text().trim();
    var secondCatName = $link.closest('.cc-menu__multipleBlockSection').prev('.cc-menu__secondLevelColumn').find('.cc-menu__secondLevel__link').attr('aria-label') || $link.closest('.cc-menu__multipleBlockSection').prev('.cc-menu__secondLevelColumn').find('.cc-menu__secondLevel__title').text().trim();
    var firstCatName = $link.closest('.cc-menu__secondLevel').siblings('.cc-menu__level__link.cc-menu__firstLevel__link').attr('aria-label') || $link.closest('.cc-menu__secondLevel').siblings('.cc-menu__level__link.cc-menu__firstLevel__link').find('.cc-menu__firstLevel__title').text().trim();
    var parentCatName = firstCatName + ' - ' + secondCatName;
    events.ga4ClickMenuNav(3, "PROMO - " + parentCatName + " - " + blockTitle);
    events.trackGAEvent('collection block', parentCatName, blockTitle);
});

/**
 * @description Handles click on a category in the mobile menu, fetches parent and current category, and tracks the event
 */
$(document).on('click', '.js-category-container .cc-menu__secondLevel__link', function() {
    var $category = $(this);
    if (!$category.data('subcategories')) {
        var parent = $category.data('analytics-parent');
        var name = $category.data('name') || $category.attr('aria-label') || $category.text().trim();
        if (parent) {
            events.ga4ClickMenuNav(2, parent + " - " + name);
            events.trackGAEvent('dropdown', parent, name);
        } else {
            events.ga4ClickMenuNav(1, name);
            events.trackGAEvent('main menu', name, '', 0, true);
        }
    }
});

/**
 * @description Handles click on a brand category in PDP
 */
$('body').on('click', '.js-analytics-selectBrandName', function() {
    const button = $(this);
    const pageUrl = button.data('page-url');
    const buttonPosition = button.data('button-position');
    if (!button || !pageUrl || !buttonPosition) {
        return;
    }
    events.ga4SelectBrandName({pageUrl, buttonPosition});
});


/**
 * @description register the quantity variation of product
 * @param pid {String} the id of the product changed
 * @param qty {Int} the new quantity selected
 */
$('body').on('analytics:updateProductQuantity', function(e, data) {
    utils.updateProductQuantity(data.pid, data.qty);
});

/**
 * @description It is triggered when a user clicks on brand logo
 */
$(document).on('click', '.js-analytics-brandLogoComponent', function(e) {
    const menuItem = $(this);
    if (menuItem && menuItem.attr('data-menu-selection')) {
        const logoComponentData = menuItem.attr('data-menu-selection');
        $('body').trigger('analytics:clickBrandLogoComponent', logoComponentData);
    }
});

/**
 * @description variationSelectedPLP listener
 * @param pid {pid} the id of the product added to the cart
 */
$('body').on('analytics:variantSelectionPLP', function(e, data) {
    let product = data.productData;
    var products = [{
        'name': product.name,
        'id': product.id,
        'dimension1': product.dimension1,
        'dimension2': product.dimension2,
        'dimension3': product.dimension3,
        'price': product.price,
        'brand': product.brand,
        'category': product.category,
        'description': product.description,
        'productUrl': product.producturl,
        'categoryUrl': product.categoryurl,
        'imageUrl': product.imageurl,
        'variant': product.color + (product.size ? " | " + product.size : ""),
        'discount': product.discount,
        'promotionName': product.promotionName,
        'position': product.position,
        'genderName': product.genderName,
        'itemSeason': product.itemSeason,
        'stockStatus': product.stockStatus
    }];
    utils.extendProductDataWithGA4Categories(products[0], product);
    var ga4Products = utils.ga4GetProducts(products);
    // Launch the event depending on variationType, either color or size selection if uknown then use select_item
    if (data.variationType === 'color') {
        events.ga4SelectColor(product.id, product.color);
    } else if (data.variationType === 'size') {
        events.ga4SelectSize(product.id, product.size);
    } else {
        events.ga4SelectItem(window.bata_com_ns.analytics.currency, ga4Products);
    }
    //launch the event variantSelected
    events.variantSelected(window.bata_com_ns.analytics.currency, products);
});

/**
 * @description Checkout progress event
 * @param data {String} checkout step name
 */
//checkout inversion
$('body').on('analytics:checkoutProgress', function() {
    var products = utils.getCheckoutProducts(3, false);
    var ga4Products = utils.ga4GetProducts(products);
    var ga4CheckoutData = utils.ga4GetCartData();
    var checkoutData = {
        currencyCode: window.bata_com_ns.analytics.currency,
        coupon: ga4CheckoutData.couponNames,
        value: ga4CheckoutData.value,
        stepLabel: "shipping info",
        stepNumber: 1
    };
    events.ga4CheckoutProgress(checkoutData, ga4Products);
});

/**
 * @description collect the cart product views / impressions
 */
$('body').on('analytics:viewMiniCart', function() {
    var products = utils.getProductsCartData(window.bata_com_ns.analytics.pageType);
    var ga4Products = utils.ga4GetProducts(products);
    events.ga4ViewItemList(window.bata_com_ns.analytics.currency, ga4Products);
    events.trackProductImpression(window.bata_com_ns.analytics.currency, products);
});

/**
 * @description collect the recommendations products views
 */
$('body').on('analytics:recommendationsLoaded', function(e, recommendationContainer) {
    utils.trackRecommendationsLists(recommendationContainer);
});

/**
 * @description GA4 track checkout progress
 */
$('body').on('analytics:shippingSubmitted', function(e, order) {
    if (!order) {
        return;
    }
    //checkout inversion
    var products = utils.getCheckoutProducts(2, false);
    let ga4Products = utils.ga4GetProducts(products);
    let checkoutData = {
        currency: window.bata_com_ns.analytics.currency,
        shipping: order.totals && order.totals.shippingTotalAfterDiscountValue,
        shippingTier: order.shipping && order.shipping.length && order.shipping[0].selectedShippingMethod && order.shipping[0].selectedShippingMethod.displayName,
        coupon: order.couponsName,
        value: order.totals && order.totals.grandTotalDecimal
    };
    events.ga4AddShippingInfo(checkoutData, ga4Products);
});

/**
 * @description GA4 newsletter form submitted
 */
$('body').on('analytics:newsletterSubscribe', function() {
    events.ga4Subscribe("newsletter");
});

/**
 * @description GA4 Add to cart submitting -> extend the form with analytics list id
 */
$('body').on('analytics:addToCartSubmitting', function(e, form) {
    if (window.bata_com_ns.analytics.pageType === "category") {
        form.analyticsListId = $("div.grid-footer > input.category-id").val() || $('.js-analytics-search-category').data('analytics-category-id') || 'product search';
    } else if (window.bata_com_ns.analytics.pageType === "product") {
        form.analyticsListId = $('.analytics-productPDP.analytics-product').data('listId') || 'detail';
    } else {
        form.analyticsListId = 'detail';
    }
});

$('body').on('analytics:brandSecondCategoryLevel', function(secondLevelData) {
    const eventData = {
        menuLevel:"2 - second level category brand",
        menuSelection: secondLevelData || "",
    };
    events.ga4CheckoutProgress(eventData);
});

$('body').on('analytics:clickBackInStock', function(e, buttonData) {
    if (!buttonData || !$('#product-id').length) {
        return;
    }

    const productId = $('#product-id').val();
    const elementId = buttonData.id || '';
    const elementMessage = buttonData.message || '';

    let $analyticsProduct;

    if (utils.getPageType() === "product") {
        $analyticsProduct = $('.analytics-productPDP');
    } else {
        $analyticsProduct = $(`.analytics-product.${productId}`);
    }

    const clickBackInStockData = {
        'linkUrl': $analyticsProduct.data('producturl') || '',
        'elementId': elementId,
        'elementText': elementMessage,
    };
    events.ga4ClickBackInStock(clickBackInStockData);
});

$('body').on('analytics:clickBrandLogoComponent', function(e, brandName) {
    const eventData = {
        menuLevel:"3 - brand logo component",
        menuSelection: brandName || "",
    };
    events.ga4BrandLogoComponent(eventData);
});

/**
 * @description clickDiscoverBrand listener
 * @param discoverBrand {String} the name of the brand clicked
 */
$('.js-analytics-clickDiscoverBrand').on('click', function() {
    const discoverBrand = $(this).data('menu-selection');

    if (!discoverBrand) {
        return;
    }

    const discoverBrandData = {
        menuLevel: "discover - brand",
        menuSelection: discoverBrand,
    };

    events.ga4ClickDiscoverBrand(discoverBrandData);
});

/**
 * @description on editorial product click send select_item GA4 event
 */
$(document).on('click', '.js-editorial-pdp a.js-analytics-productClick', function() {
    let currentProductId = utils.getProductDataPDP()[0].id || 'undefined product';
    let analyticsProduct = $(this).closest('.product').find('.analytics-product');
    let sectionTitle = $('.js-editorial-pdp .cc-recommended-slider__title-link').text().trim() || 'Editorial PDP';

    if (analyticsProduct.data('name') && analyticsProduct.data('id')) {
        let productData = [utils.getProductClickTileData(analyticsProduct)];
        productData[0].list_name = `PDP - ${currentProductId} - ${sectionTitle}`;

        let ga4ProductsList = utils.ga4GetProducts(productData);
        events.ga4SelectItem(window.bata_com_ns.analytics.currency, ga4ProductsList);
    }
});

/**
 * @description GA4 scroll position
 */
$(window).bind('scroll', function() {
    utils.trackScrollPosition();
});

$('body').on('change', 'input[name="storeDetails"]', function() {
    events.ga4SaveCreditCard();
});

/**
 * @description GA4 Click on footer item in column
 */
$('.cc-footer .cc-footer-main .cc-footer-nav-list a').on('click', function() {
    let footer_selection = $(this);
    let level = $(this).closest('.col-12').find('.cc-footer-nav-title');
    events.ga4SelectFooterMenu(footer_selection, level);
});

/**
 * @description GA4 Click on Footer CTA button
 */
$('.cc-footer .cc-footer-custom-section-button > a').on('click', function() {
    let footer_selection = $(this);
    let level = $(this).closest('.col-12').find('.cc-footer-custom-section-title');
    events.ga4SelectFooterMenu(footer_selection, level);
});



// WEBPACK FOOTER //
// ./cartridges/app_checkout_redesign/cartridge/client/default/js/analytics/analytics-listener.js